import React from 'react';
import { PetVisual } from '../visuals';
import './FutureWorlds.css';

/**
 * Where Petlings might go next, as plans rather than promises.
 *
 * Game names only, as plain text: no logos or game art, which their owners
 * do not allow for this, and nothing that reads as a partnership. The small
 * print says so.
 */
export const FUTURE_WORLDS = [
  {
    game: 'Roblox',
    status: 'Planning',
    pet: 'mocchi_rabbit',
    title: 'Pocket Grove',
    blurb: 'A garden of our own on Roblox, where your Petling tidies, blooms and plays mini-games with friends’ pets.',
  },
  {
    game: 'Hytale',
    status: 'Exploring',
    pet: 'baby_dragon',
    title: 'Petlings on Hytale servers',
    blurb: 'Hytale’s servers speak the same language as our Minecraft plugin, so your companion could explore a whole new world with you.',
  },
  {
    game: 'Discord',
    status: 'Exploring',
    pet: 'nimbus_pup',
    title: 'Pets on a call',
    blurb: 'An Activity where friends raise and play with their Petlings together, right inside a voice call.',
  },
  {
    game: 'Stardew Valley',
    status: 'Idea',
    pet: 'sheep',
    title: 'A farmhand with fur',
    blurb: 'A free community mod where your Petling helps tend the farm and reacts to your day.',
  },
  {
    game: 'Fortnite',
    status: 'Idea',
    pet: 'star_sprite',
    title: 'A Petlings island',
    blurb: 'A short, bright island of challenges with your pet cheering you on.',
  },
];

export default function FutureWorlds() {
  return (
    <section className="future-section">
      <div className="container">
        <div className="future-head">
          <span className="future-eyebrow">Future work</span>
          <h2>Future worlds</h2>
          <p>
            Your Petling already follows you in Minecraft, on RevivalSMP and VanillaTown. Here is where we would love
            it to go next. These are our plans, not announced partnerships.
          </p>
        </div>
        <div className="future-grid">
          {FUTURE_WORLDS.map((w) => {
            return (
              <article key={w.game} className="future-card">
                <div className="future-card-top">
                  <span className="future-game">{w.game}</span>
                  <span className={`future-status future-status-${w.status.toLowerCase()}`}>{w.status}</span>
                </div>
                <div className="future-pet"><PetVisual petId={w.pet} size={96} mood="happy" /></div>
                <h3>{w.title}</h3>
                <p>{w.blurb}</p>
              </article>
            );
          })}
        </div>
        <p className="future-small">
          Petlings is not affiliated with, endorsed by, or sponsored by Roblox, Mojang or Microsoft, Hypixel Studios,
          Discord, ConcernedApe or Epic Games. Game names belong to their owners and are used here only to describe
          our plans.
        </p>
      </div>
    </section>
  );
}
